// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"r2","tag":"r3","isRental":"r4","title":"r5","title2":"r6","description":"r7","cta":"r8","ratingLabel":"r9","ratingLabelSmallScreen":"r-","iconInHotspotVideo":"r_"};